import { render, staticRenderFns } from "./MypageOneTimePassInputPage.vue?vue&type=template&id=2dc09b1e"
import script from "./MypageOneTimePassInputPage.vue?vue&type=script&lang=ts"
export * from "./MypageOneTimePassInputPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports